<template>
	<div>
		<div class="container flex-start">
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane label="需求复审" name="first"></el-tab-pane>
				<el-tab-pane label="情感圈复审" name="second"></el-tab-pane>
				<el-tab-pane label="热点复审" name="third"></el-tab-pane>
			</el-tabs>
			<div class="search">
				<div class="flex-start">
					<div class="search_item">
						<div>审核状态：</div>
						<el-select v-model="reqOrderType" placeholder="请选择">
							<el-option v-for="item in orderTypeList" :key="item.key" :label="item.value"
								:value="item.key">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="btn_warp">
					<div class="btn" @click="queryBtn">查询</div>
				</div>
			</div>
			<div v-loading="loading" class="req-warp">
				<div v-if="tableData.length > 0">
					<div class="req-warp">
						<el-table :data="tableData" border style="width: 100%">
							<el-table-column fixed align="center" label="申请人" width="140">
								<template slot-scope="scope">
									<div class="flex-center avatarwarp">
										<div class="avatar">
											<img :src="showAvatarUrl(scope.row.sdu_avatarUrl)"></img>
										</div>
										<div class="nickName">{{scope.row.sdu_nickName}}</div>
									</div>
								</template>
							</el-table-column>
							<el-table-column align="center" label="需求附件" width="160">
								<template slot-scope="scope">
									<div v-if="scope.row.reqAttachList.length == 0">--</div>
									<el-image v-else style="width: 30px; height: 30px"
										:src="baseUrlpath + scope.row.reqAttachList[0].filePath" @error="imgOnError"
										:preview-src-list="$util.previewSrcList( scope.row.reqAttachList )">
									</el-image>
								</template>
							</el-table-column>
							<el-table-column prop="sdr_contents" align="center" label="发布内容" width="400">
								<template slot-scope="scope">
									<div v-if="activeName == 'first'" class="txt_left">{{$util.filterHtml(scope.row.sdr_contents)}}</div>
									<div v-else-if="activeName == 'second'" class="txt_left">{{$util.filterHtml(scope.row.sdre_contents)}}</div>
									<div v-else-if="activeName == 'third'" class="txt_left">{{$util.filterHtml(scope.row.sdrr_contents)}}</div>
								</template>
							</el-table-column>
							<el-table-column prop="addTime" align="center" label="发布日期" width="220">
							</el-table-column>
							<el-table-column align="center" prop="examineStt" label="审核状态" width="120">
								<template slot-scope="scope">
									<div>{{$util.getDisPlay(scope.row.examineStt,$util.examineSttList)}}</div>
								</template>
							</el-table-column>
							<el-table-column fixed="right" align="center" label="操作" width="200">
								<template slot-scope="scope">
									<div v-if="scope.row.examineStt == '1'">
										<el-button @click="putDownReq(scope.row)" type="text" size="small">审核拒绝
										</el-button>
									</div>
									<div v-if="scope.row.examineStt == '2'">
										<el-button @click="putOnReq(scope.row)" type="text" size="small">审核通过
										</el-button>
									</div>
									<div v-if="scope.row.examineStt == '3'">
										<el-button @click="putOnReq(scope.row)" type="text" size="small">审核通过
										</el-button>
										<el-button @click="putDownReq(scope.row)" type="text" size="small">审核拒绝
										</el-button>
									</div>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="pagination_warp">
						<el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage1"
							:page-size="pageSize" layout="total, prev, pager, next" :total="total">
						</el-pagination>
					</div>
				</div>
				<div v-else class="empty-msg">
					<el-empty description="暂无内容"></el-empty>
				</div>
			</div>
		</div>
		<div>
			<el-image ref="previewImg" style="width: 0px; height: 0px" :src="imgSrcUrl" @error="imgOnError"
				:preview-src-list="imgPreUrls">
			</el-image>
		</div>
		<el-dialog title="提示" :visible.sync="rejectDialogVisible" width="30%" center>
			<el-input type="textarea" :rows="4" placeholder="输入拒绝原因" v-model="rejectMsg" maxlength='100'
				show-word-limit></el-input>
			<span slot="footer" class="dialog-footer">
				<el-button @click="cancelReject()">取 消</el-button>
				<el-button type="primary" @click="dealReject()">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		queryUrl,
		doPost
	} from '@/api/index';
	import {
		Toast
	} from 'mint-ui';
	export default {
		data() {
			return {
				currentPage1: 1,
				tableData: [],
				total: 0,
				pageSize: 9,
				baseUrlpath: '',
				reqType: 'all',
				reqTypeList: [],
				reqOrderType: '3',
				orderTypeList: [],
				loading: false,
				defalutImg: require('@/assets/icon/noimg.jpg'),
				imgSrcUrl: '',
				imgPreUrls: [],
				rejectDialogVisible: false,
				rejectMsg: '',
				dealingId: '',
				activeName: 'first'
			}
		},
		created() {
			this.baseUrlpath = this.baseUrl;
			this.reqTypeList = JSON.parse(JSON.stringify(this.$util.reqList));
			this.reqTypeList.unshift({
				'key': 'all',
				'value': '不限'
			})
			this.orderTypeList = JSON.parse(JSON.stringify(this.$util.examineSttList));
			this.orderTypeList.unshift({
				'key': 'all',
				'value': '不限'
			})
			this.query();
		},
		methods: {
			handleCurrentChange(e) {
				// console.log(e)
				this.currentPage1 = e;
				this.tableData = [];
				this.total = 0;
				this.query()
			},
			handleClick(tab, event) {
				// console.log(this.activeName);
				this.queryBtn()
			},
			viewWorkPicture(attalist) {
				// console.log(attalist)
				if (attalist == undefined || attalist.length == 0) {
					this.$util.warnMsg('无附件');
				} else {
					this.imgSrcUrl = attalist[0].sdua_filePath
					this.imgPreUrls = []
					for (var index in attalist) {
						this.imgPreUrls.push(attalist[index].sdua_filePath)
					}
					this.$refs.previewImg.showViewer = true;
				}
			},
			imgOnError(e) {
				const img = e.srcElement;
				img.src = this.defalutImg;
				img.onerror = null
			},
			handleComfireClick() {

			},
			queryBtn() {
				this.currentPage1 = 1;
				this.query();
			},
			query() {
				this.loading = true
				var vm = this;
				var params = {};
				params.currentPage = vm.currentPage1;
				params.pageSize = vm.pageSize;
				params.examineStt = vm.reqOrderType;
				var url = "";
				if (this.activeName == 'first') {
					url = "reviewReqcase";
				} else if (this.activeName == 'second') {
					url = "reviewEmotionalcase";
				} else if (this.activeName == 'third') {
					url = "reviewhotspotcase";
				}
				queryUrl("/apis/" + url, params).then(res => {
					this.loading = false
					vm.tableData = res.reqList;
					vm.total = res.totalNum;
				});
			},
			goToDetail(itemInfo) {
				this.$router.push({
					name: 'reqDetail',
					query: {
						reqNo: itemInfo.sdr_reqId
					}
				});
			},
			showAvatarUrl(avatarUrl) {
				if (avatarUrl) {
					if (avatarUrl.indexOf('http') >= 0) {
						return avatarUrl;
					} else {
						return this.baseUrlpath + avatarUrl;
					}
				}
			},
			putDownReq(info) {
				var vm = this;
				this.$confirm('是否确定审核拒绝？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					vm.rejectCertification(info);
				})
			},
			putOnReq(info) {
				var vm = this;
				this.$confirm('是否确定审核通过？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					vm.dealputOnReq(info);
				})
			},
			async dealputOnReq(info) {
				var params = {};
				this.$util.showLoading()
				params.reqNo = info.sdr_reqId || info.sdre_reqId || info.sdrr_reqId
				const initres = await doPost("/apis/examinePass", params);
				if (initres.ec == '0') {
					this.$util.hideLoading()
					this.$util.msg("审核成功");
					this.query();
				}else{
					this.$util.hideLoading()
				}
			},
			cancelReject() {
				this.rejectDialogVisible = false
				this.rejectMsg = ""
			},
			async dealReject() {
				if (this.rejectMsg.length == 0) {
					this.$util.warnMsg("请输入拒绝原因");
					return;
				}
				var vm = this;
				var params = {};
				params.reqNo = this.dealingId
				params.rejectMsg = this.rejectMsg;
				this.$util.showLoading()
				this.rejectDialogVisible = false
				const initres = await doPost("/apis/examineReject", params);
				if (initres.ec == '0') {
					this.$util.hideLoading()
					this.$util.msg("拒绝成功");
					this.query();
				}else{
					this.$util.hideLoading()
				}
			},
			rejectCertification(info) {
				this.rejectDialogVisible = true
				this.dealingId = info.sdr_reqId || info.sdre_reqId || info.sdrr_reqId
			}
		}
	}
</script>

<style scoped="scoped" lang="scss">
	.req-warp {
		width: 100%;
		margin-top: 30px;

		.avatarwarp {
			.avatar {
				width: 30px;
				height: 30px;
				overflow: hidden;
				border-radius: 50px;

				img {
					width: 100%;
					height: 100%;
				}
			}

			.nickName {
				font-size: 12px;
				padding-left: 26px;
				width: 100px;
				text-align: left;
			}
		}
	}

	.container {
		width: 90%;
		margin: 0 auto;
		align-items: flex-start;
		flex-direction: column;
		.pagination_warp {
			padding: 0 20px 20px 0;
			margin-top: 60px;
			width: 100%;
		}
		.empty-msg {
			flex: 1;
			height: calc(100vh - 70px);
			display: flex;
			justify-content: center;
			width: 100%;
		}

		.search {
			margin-top: 20px;
			margin-bottom: 30px;
			display: flex;
			align-items: center;

			.search_item {
				display: flex;
				align-items: center;
				justify-content: flex-start;
			}

			.search_item:not(:first-child) {
				margin-left: 26px;
			}

			.btn_warp {
				display: flex;
				justify-content: flex-start;
				align-items: center;
				margin-left: 20px;

				.btn {
					background-color: #C88854;
					color: #FFFFFF;
					width: 80px;
					margin: 0 10px;
					padding: 6px 0;
					border-radius: 20px;
					font-size: 14px;
					cursor: pointer;
				}

				.rest_btn {
					border: 1px solid #C88854;
					color: #C88854;
					width: 80px;
					margin: 0 10px;
					padding: 6px 0;
					border-radius: 20px;
					font-size: 14px;
					cursor: pointer;
				}
			}
		}
	}

	.req-item {
		border-radius: 8px;
		box-shadow: 0px 4px 16px 1px rgba(0, 0, 0, 0.06);
		overflow: auto;
		margin-right: 12px;
		margin-bottom: 12px;
		padding: 20px 20px;
	}

	::v-deep .el-tabs__item {
		width: 200px;
	}
</style>
